import { render } from "./LookupHistoryTable.vue?vue&type=template&id=cd0bd230"
import script from "./LookupHistoryTable.vue?vue&type=script&lang=js"
export * from "./LookupHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__